"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Read-only cards for the Concur expense WRITE tools. They show what was
 * requested (from the tool input) and the outcome (applied, warnings, what the
 * expense form still needs). Keyed by bare tool name.
 */
export const concurExpenseWriteToolRegistry = {
  concurAddExpense: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./expense-write-views").then(({ ConcurAddExpenseToolView }) => ({
        default: ConcurAddExpenseToolView,
      }))
    ),
  },
  concurUpdateExpenseEntry: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./expense-write-views").then(
        ({ ConcurUpdateExpenseEntryToolView }) => ({
          default: ConcurUpdateExpenseEntryToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
